import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dictionary",
  "use": "icon-dictionary-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-dictionary\"><defs><style>#icon-dictionary .cls-1{ }</style></defs><title>业务字典</title><path class=\"cls-1\" d=\"M3.63,3V16h9.3a1.15,1.15,0,0,0,1.17-1.17V3Zm8.48,6.59H5.83V9h6.28Zm0-1.89H5.83V7.06h6.28Zm0-1.94H5.83V5.12h6.28Z\" /><path class=\"cls-1\" d=\"M2.51,1.34A.53.53,0,0,0,2,1.9v.52A.58.58,0,0,0,2.51,3h.56V16H2.51a1.16,1.16,0,0,1-1.18-1.17v-13A1.16,1.16,0,0,1,2.51.68H12.93a1.49,1.49,0,0,1,1.17.66Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol